import React, { useEffect } from 'react'
import {connect, useDispatch, useSelector} from 'react-redux'
import {Field, InjectedFormProps, reduxForm} from 'redux-form'
import {FormButtons, renderers, validations} from '../../../components'
import * as rest from '../../../services'
import { showErrorToast, showSuccessToast } from '../../../state/toasts'
import * as ReactBootstrap from "react-bootstrap";
import {Ticket} from "../../../types";

const GSXClassificationInfoFormName = 'GSXClassificationInfoForm'
interface GSXClassificationInfoFormProps extends InjectedFormProps {
    ticket?:Ticket
}
export type GSXClassificationInfoProps={
    ticket:Ticket
    onTicketUpdate:(t:Ticket)=>void
}

const GSXClassificationInfoFormHTML = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  ticket,
}:GSXClassificationInfoFormProps) => {
 const { boolean_list } = useSelector((state) => state.lists)
  return (
      <form onSubmit={handleSubmit}>
        <ReactBootstrap.Col md={6} xs={12} lg={12}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            name="repair_classification"
            label="Repair Classification"
          >
            {['DIRECT', 'NEEDS_EXTRA_UNDERSTANDING', 'INDIRECT'].map((sp) => (
              <option key={sp} value={sp}>
                {sp.replace(/_/g, " ")}
              </option>
            ))}
          </Field>
                 <h6>Current Value:{ticket?.repair_classification}</h6>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={12}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            name="gsx_coverage_option"
            label="GSX Coverage Option"
          >
            {[
              'BATTERY',
              'DISPLAY',
              'VMI_YELLOW',
              'APPLECARE_PLUS',
              'VMI_RED',
              'VMI_GREEN',
              'THEFTLOSS',
            ].map((sp) => (
              <option key={sp} value={sp}>
                {sp}
              </option>
            ))}

          </Field>
            <h6>Current Value:{ticket?.gsx_coverage_option}</h6>
        </ReactBootstrap.Col>

           <ReactBootstrap.Col md={6} xs={12} lg={12}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            name="contact_customer_for_requote"
            label="Contact Customer for Requote"
          >
            {boolean_list &&
                boolean_list.map((sp) => (
                  <option key={sp.key} value={sp.value}>
                    {sp.text}
                  </option>
                ))}

          </Field>

            <h6>Current Value:{ticket?.contact_customer_for_requote?"YES": "No"}</h6>

                    <Field
              component={renderers.renderSelectField}
              as="select"
              validate={[validations.required]}
              name="is_pop_uploaded"
              label="Is POP Content"
            >
              {boolean_list &&
                boolean_list.map((sp) => (
                  <option key={sp.key} value={sp.value}>
                    {sp.text}
                  </option>
                ))}
            </Field>
               <h6>Current Value:{ticket?.is_pop_uploaded?"YES": "No"}</h6>

        </ReactBootstrap.Col>

        <FormButtons
          submitting={submitting}
          pristine={pristine}
          reset={reset}
        />
      </form>

  )
}

const GSXClassificationInfoForm = reduxForm({
  form: GSXClassificationInfoFormName,
})(GSXClassificationInfoFormHTML)


const GSXClassificationInfo = ({ ticket, onTicketUpdate }:GSXClassificationInfoProps) => {
  const dispatch = useDispatch()
  const GSXClassificationInfoFormWithData = connect((state) => ({
    initialValues: {
          repair_classification:ticket.repair_classification,
          gsx_coverage_option:ticket.gsx_coverage_option
      },
  }))(GSXClassificationInfoForm)
  useEffect(() => {
    connect((state) => ({
      initialValues: {
          repair_classification:ticket.repair_classification,
          gsx_coverage_option:ticket.gsx_coverage_option
      }
    }))
  }, [ticket])
  const handleSave = (data) => {
    new rest.TicketService(ticket.url)
      .makePatchRequest({...{
          repair_classification:ticket.repair_classification,
          gsx_coverage_option:ticket.gsx_coverage_option,

      },...data })
      .then((response) => {
        onTicketUpdate(ticket)
        dispatch(
          showSuccessToast(
            'Success',
            `Ticket GSX Repair Classification Information has been saved.`
          )
        )
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  return (
     <ReactBootstrap.Card className="mt-5">
          <ReactBootstrap.Card.Title className="card-header bg-dark text-white card-header">
            GSX Classification Info
          </ReactBootstrap.Card.Title>
          <ReactBootstrap.Card.Body>
      <GSXClassificationInfoFormWithData
        ticket={ticket}
        onSubmit={handleSave}
      />
          </ReactBootstrap.Card.Body>
     </ReactBootstrap.Card>
  )
}
export default GSXClassificationInfo
